import React, { useEffect } from 'react'
import Bredcom from '../../Bredcom/Main'
import Header from '../../headerone/Main'
import Blog from '../../menhome/Blog'
import Newlast from '../../menhome/Newlast'
import Allresources from '../menresources/Allresources'


function Main() {

  useEffect(() => {
    document.getElementById("title").innerHTML="Resources";
  }, [])

  return (
    <>
        <Header/>

        <div className="page-wrapper">
        <Bredcom 
            subtitle="Home"
            title="resources"
            subtitledown="Resources"
           />
            <Allresources/>
            <Blog/>
            <Newlast/>
        </div>
    </>
  )
}

export default Main